import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { PassingModeRepository } from '@/store/passing-mode-state/passing-mode-state.repository';

interface IgetPassingModeAddDrawerObjectProps {
  store?: PassingModeRepository;
  formObject?: DynamicForm;
  action?: () => void;
  toggleVisibility?: () => void;
}

export const getPassingModeAddDrawerObject = ({ store, formObject, toggleVisibility, action }: IgetPassingModeAddDrawerObjectProps): any => {
  return {
    title: 'settings.passingMode.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.passingMode.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.passingMode.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
